import { CommentList } from "@/features/comments/components/CommentList"

interface DiscussionTabProps {
  entityId: string
  searchQuery?: string
  canComment: boolean
  canReply?: boolean
  canModerate: boolean
}

export function DiscussionTab({
  entityId,
  searchQuery = "",
  canComment,
  canReply,
  canModerate,
}: DiscussionTabProps) {
  return (
    <div className="py-9">
      <CommentList
        entityType="community"
        entityId={entityId}
        canComment={canComment}
        canReply={canReply}
        canModerate={canModerate}
        searchQuery={searchQuery}
      />
    </div>
  )
}
